import { useEffect } from "react"

/**
 * The BorrowerPlatform component dynamically loads a script from an external source and renders its
 * content within a specified target element.
 * @returns The `BorrowerPlatform` component is returning a `<div>` element with the id
 * "target-element" and an inline style setting the height to "100vh". This `<div>` element is the
 * target element where the script loaded from "https://borrower.lendflow.com/lfbp.js" will render the
 * Borrower Platform content.
 */

function BorrowerPlatform() {

    /***
     <script src="https://borrower.lendflow.com/lfbp.js?token=borrower-platform-5e41f448af3d470fac7ed44a967fda47&branding=1741&target=target-element" defer></script>
     <div id="target-element"></div> 
    ***/

    // Set up the <script> element
    useEffect(() => {
        // Initialize script
        const script = document.createElement("script")
        script.src = "https://borrower.lendflow.com/lfbp.js?token=borrower-platform-5e41f448af3d470fac7ed44a967fda47&branding=1741&target=target-element"
        script.defer = true;

        // Add the script inside the <body> element
        document.body.appendChild(script);

        // Prints the <body> element in the console. You should be able to see the <script> element that was added
        // console.log(document.body);

        // Cleanup function to remove the script on component unmount, e.g. when the user exits
        return () => {
            document.body.removeChild(script);
        };
    }, [])

    return (
        <div id="target-element" style={{ height: "100vh" }}></div>
    )
}

export default BorrowerPlatform